<script>
import { Pie } from 'vue-chartjs'

function setupGraphData (self, graphData) {
  return {
    data: {
      labels: graphData.map(data => data.label),
      datasets: [
        {
          backgroundColor: graphData.map(data => data.colour),
          data: graphData.map(data => data.weight)
        }
      ]
    },
    options: {
      animation: {
        animateScale: true
      },
      responsive: true,
      maintainAspectRatio: true,
      legend: {
        display: false
      }
    }
  }
}

export default {
  extends: Pie,
  name: 'ResourceWeightGraph',
  props: {
    active: {
      type: Boolean,
      required: true
    },
    graphData: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      initiallyRendered: false
    }
  },
  methods: {
    renderData () {
      this.initiallyRendered = true
      if (this.$data._chart) {
        this.$data._chart.destroy()
      }
      let {data, options} = setupGraphData(this, this.graphData)
      this.renderChart(data, options)
    }
  },
  watch: {
    graphData (value) {
      if (value && !this.initiallyRendered) {
        this.renderData()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/resources/ResourceWeightGraph.vue